export class CarreraInscripcion {
    nombreCarrera: string = "";
    institucion: string = "";
}
